import "./App.css";
import Home from "./helper/Home";

function App() {
  return (
    <div>
      <Home />
    </div>
  );
}

export default App;
